module.exports = __webpack_public_path__ + "img/mac-icon2.6c3e973.png";